export default __webpack_public_path__ + "static/media/split-a.d31fd5d0.svg";